// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c9d0a0bf","732":"4f78c281","977":"84e22d85"}[chunkId] + ".chunk.js";
};